import React from 'react';

export default function WrapperProvider({
  wrappers,
  children,
}: React.PropsWithChildren<{ wrappers: React.ComponentType<React.PropsWithChildren<unknown>>[] }>) {
  const reversed = [...wrappers].reverse();
  return reversed.reduce((cur, Wrapper) => <Wrapper>{cur}</Wrapper>, <>{children}</>);
}
